import { ApplicationStyles, Colors, Metrics } from 'app/styles';
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    card: {
        'margin-right': 8,
        overflow: 'hidden',
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    gridSeparatorRight: {
        paddingRight: '1%',
    },
    editIcon: {
        color: Colors.primary,
        fontSize: 20,
    },
    disabledTable: {
        background: '#f5f5f5',
        color: '#bababa',
        pointerEvents: 'none'
    },
    deleteIcon: {
        color: Colors.red,
        fontSize: 20,
    },
    gridSeparatorLeft: {
        paddingLeft: '1%',
    },
    gridSeparatorTop: {
        paddingTop: '16px',
    },
    numericInput: {
        flex: 1,
        width: '100%',
        marginBottom: 8
    },
    buttonsContainer: {
        marginTop: 10,
        marginBottom: 10,
        display: 'flex',
        flex: 1,
        justifyContent: 'flex-end'
    },
    button: {
        marginLeft: 8,
    },
    icon: {
        minWidth: '30px',
        fontSize: '20px'
    },
    itemText: {
        minHeight: 23,
		fontSize: '20px'
    },
    addItem: {
        //display: 'flex',
        //justifyContent: 'flex-end',
    },
    hidden: {
        display: 'none'
    },

    align: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: Metrics.baseMargin,
        marginBottom: Metrics.baseMargin,
        justifyContent: 'space-between',
        alignItems: 'baseline',
    },
    alingBase: {
        alignItems: 'baseline',
    },
    inputSelect: {
        flex: 1,
        width: '100%',
        marginBottom: 8
    },
    flex: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
    },
    justifyContentFlexEnd: {
        display: 'flex',
        padding: '0'
    }
}));

export const styles = ({
    ...ApplicationStyles.margins,
    ...ApplicationStyles.flexBox,
    addButton: {
        color: Colors.primary,
    },
    radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
    }
})
